require('../modules/web.timers');
require('../modules/web.immediate');
require('../modules/web.dom.iterable');
module.exports = require('../modules/_core');



//////////////////
// WEBPACK FOOTER
// /Users/mattgilson/Sites/tone.test/wp-content/themes/tone/node_modules/core-js/web/index.js
// module id = 300
// module chunks = 0